/* eslint-disable max-lines */
/* eslint-disable camelcase */
/* eslint-disable max-depth */
/* eslint-disable operator-linebreak */
/* eslint-disable max-statements */
/* eslint-disable no-magic-numbers */

const config = {
    searchList: {
        searchTxt: [
            {
                name: '客户订单号',
                value: 'customerOrderNo',
                unfold: true,
                span: 3,
                type: 'input'
            }, {
                name: '调整类型',
                value: 'adjustType',
                type: 'select',
                unfold: true,
                options: [],
                optionNum: 'ADJUST_TYPE',
                span: 3
            }, {
                name: '调整状态',
                value: 'applyStatus',
                type: 'select',
                unfold: true,
                options: [],
                optionNum: 'APPLY_STATUS',
                span: 3
            },
            {
                'name': '仓库',
                'value': 'whName',
                'unfold': true,
                'advanceConfig': [
                    { 'prop': 'cdwhName', 'value': '仓库名称' },
                    { 'prop': 'whCode', 'value': '仓库编码' }
                ],
                'tableConfig': [
                    { 'prop': 'whCode', 'value': '仓库编码' },
                    { 'prop': 'cdwhName', 'value': '仓库名称' }
                ],
                'advanceUrl': 'cdWarehouse/search?cdwhIsStop=0',
                'cbParams': [
                    'whCode', 'cdwhName#whName'
                ],
                'type': 'advance',
                'span': 3
            },
            {
                name: '创建时间',
                value: 'createTime',
                type: 'time',
                unfold: true,
                timeNum: 60,
                span: 7
            }],
        unfoldState: false,
        advancedBtn: true
    },
    table:
    {
        height: 400,
        columns: [
            {
                label: '客户订单号',
                prop: 'customerOrderNo',
                align: 'center',
                columnStick: true,
                sort: true
            },
            {
                label: '仓库',
                prop: 'whCodeName',
                align: 'center',
                columnStick: true,
                sort: true
            },
            {
                label: '客户',
                prop: 'customerCodeName',
                align: 'center',
                columnStick: true,
                sort: true
            },
            {
                label: '调整状态',
                prop: 'applyStatusName',
                align: 'center',
                sort: true
            },
            {
                label: '调整类型',
                prop: 'adjustTypeName',
                align: 'center',
                sort: true
            },
            {
                label: '上游系统来源',
                prop: 'sourceSystemName',
                align: 'center',
                sort: true
            },
            {
                label: '原商品状态',
                prop: 'itemStatusFromName',
                align: 'center',
                sort: true
            },
            {
                label: '目标状态',
                prop: 'itemStatusToName',
                align: 'center',
                sort: true
            },
            {
                label: '创建时间',
                prop: 'createTime',
                align: 'center',
                sort: true
            },
            {
                label: '调整单号',
                prop: 'adjustNo',
                align: 'center',
                sort: true
            },
            {
                label: '申请人',
                prop: 'proposer',
                align: 'center',
                sort: true
            },
            {
                label: '创建人',
                prop: 'createUserCode',
                align: 'center',
                sort: true
            },
            {
                label: '修改人',
                prop: 'updateUserCode',
                align: 'center',
                sort: true
            }],
        action: [
            {
                type: 'text',
                label: '编辑',
                size: 'small',
                event: 'edit'
            }
        ]
    },
    page: {
        layout: 'total, sizes, prev, pager, next',
        pageSize: 10,
        pageSizes: [10, 20, 30, 50]
    },
    configuration: false,
    searchTotalTitle: [
        {
            'name': '调整单号',
            'value': 'adjustNo',
            'type': 'input'
        }
    ]
};

export default config;
